<template>
  <div class="bg-white">
    <CoverPage />
    <div class="">
      <!-- bg-hcpimg-res -->
      <div class="lg:px-12 md:px-12 px-4">
        <OurServices />
        <Collaboration />
        <CaseStudies />
      </div>
      <Testimonials />
      <HcpPartners />
      <Membership />
    </div>

    <!-- <Partners /> -->
    <FAQ />
    <LatestGrid />
    <div class="bge3ceff-opa rounded-t-5555 mt-12">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>
<script>
import CoverPage from "./components/CoverPage.vue";
import OurServices from "./components/OurServices.vue";
import Collaboration from "./components/Collaboration.vue";
import CaseStudies from "./components/CaseStudies.vue";
import Testimonials from "./components/Testimonials.vue";
import HcpPartners from "./components/HcpPartners.vue";
import Membership from "./components/Membership.vue";
import FAQ from "./components/FAQ.vue";
import LatestGrid from "./components/LatestGrid.vue";
import DownloadApp from "../home/components/DownloadApp.vue";
import Footer from "../Footer.vue";
import Partners from "../home/components/Partners.vue";
export default {
  components: {
    CoverPage,
    OurServices,
    Collaboration,
    CaseStudies,
    Testimonials,
    Membership,
    FAQ,
    LatestGrid,
    DownloadApp,
    Footer,
    HcpPartners,
    Partners,
  },
  metaInfo: {
    title: "Well-being of healthcare professionals - Caregiver Saathi",
    meta: [
      {
        name: "keyword",
        content:
          "Caregiver caregiving, agencies for caregivers,agencies for home care,assisted home care services,home care agency,home care for elderly,home care for seniors,at home nurse care,at home senior care services,care for the caregiver program,caregiver burden,wellness,well-being,health and well-being,mental health,physical health,psychological wellbeing,caregiver needs,caregiver burnout,caregiver stress,family caregiver,caregiver companion,respite care,attendant,patient support,nursing services,caregiving services,caregiver websites,Caregiving training,Caregiver support,Caregiving for specific needs,Caregiving training near me,Caregivers for seniors,Caregiving agencies,caregiving agencies in Mumbai,Caregiving and compassionate reasons,Caregiving for healthcare professionals,counselling,therapy,coaching,caregiver coaching,palliative care,caregiving support for cancer patient,attendant for dementia patient,helpline for caregiving,grief support group,volunteering,volunteering opportunities in India,grief management,employee well-being,corporate services,online forum for caregiver,community for caregivers,bhavana Issar,online learning,care management,caregiving courses,",
      },
      {
        name: "description",
        content:
          "Caregiver Saathi offers capacity building traningsnd workshops for healthcare workers to enhance their efficiency and well-being. Contact us.",
      },
    ],
  },
};
</script>
